import io from "socket.io-client";

const state = () => ({
  socket: null,
  socket_connected: false,
  socket_username: null,
  socket_users_count: null,
  socket_users: [],
});

const mutations = {
  resetSocket(state) {
    // Cerrar la conexión de la sesión anterior: un socket vivo seguiría
    // recibiendo eventos de la entidad anterior.
    try {
      if (state.socket) state.socket.disconnect();
    } catch (error) {
      console.error(error);
    }
    state.socket = null;
    state.socket_connected = false;
    state.socket_username = null;
    state.socket_users_count = null;
    state.socket_users = [];
  },
  initSocket(state, url) {
    let socket = io(url);
    state.socket = socket;
  },
  connectSocket(state, isConnected) {
    state.socket_connected = isConnected;
  },

  signInSocket(state, data) {
    state.socket_username = data.username;
    state.socket_users_count = data.users_count;
  },

  refreshUserSockets(state, data) {
    state.socket_users_count = data.users_count;
    state.socket_users.push(data.user);
  },
};

const getters = {
  socket: (state) => {
    return state.socket;
  },
  socketConnected: (state) => {
    return state.socket_connected;
  },
  socketUsername: (state) => {
    return state.socket_username;
  },
  socketUsersCount: (state) => {
    return state.socket_users_count;
  },
  socketUsers: (state) => {
    return state.socket_users;
  },
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
